<h2>{{ 'EDIT_EXHIBITOR_CATEGORIES.TITLE' | translate }}</h2>
<div class="filter-parents-wrapper">
  <app-filter-category [list]="hierarchicalProperties" [childElement]="'childHierarchicalProperties'" [type]="'hierarchical'" (send)="updateFilter($event)"></app-filter-category>
</div>
